import { IdentifierString } from '@iota/wallet-standard';

import {
  getExtendedErrorText,
  mainApi,
  queryFnNotifyWrapper,
} from 'modules/api';
import { authCacheTags } from 'modules/auth/authCacheTags';
import { getConnectedIotaProvider } from 'modules/auth/utils/getConnectedIotaProvider';

export const {
  useGetChainIdQuery,
  endpoints: { getChainId },
} = mainApi.injectEndpoints({
  endpoints: build => {
    return {
      getChainId: build.query<void, void>({
        queryFn: queryFnNotifyWrapper<void, never, IdentifierString>(
          () => {
            const provider = getConnectedIotaProvider();

            return Promise.resolve({ data: provider.getCurrentChainId() });
          },
          error => getExtendedErrorText(error, 'Failed to get chain id'),
        ),
        providesTags: [authCacheTags.account],
      }),
    };
  },
});
